import React from 'react'
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import { DateConvert } from "../../helper/DateConvert";
import { BaseUrl } from "../../helper/BaseUrl";

export default function BlogCard({ initialData }) {
    const [allData, setAllData] = useState(initialData || []);
    const [visibleCount, setVisibleCount] = useState(6);
    const [isLoadMore, setIsLoadMore] = useState(true);
    const fetcher = async () => {
        try {
            const response = await fetch(`${BaseUrl}/api/blogs`, {
                method: 'GET',
            });

            const result = await response.json();

            if (result.blogs === false) {
                throw new Error(`API error: ${result.message}`);
            }
            setAllData(result.blogs);
        } catch (error) {
            console.error('Fetch error:', error.message);
        }
    };

    useEffect(() => {
        fetcher();
    }, [])

    const handleLoadMore = () => {
        if (isLoadMore) {
            // Show 2 more cards
            setVisibleCount(prevCount => Math.min(prevCount + 3, allData.length));
            if (visibleCount + 3 >= allData.length) {
                setIsLoadMore(false); // Switch to "Load Less" mode
            }
        } else {
            // Reset to initial state
            setVisibleCount(6);
            setIsLoadMore(true); // Switch to "Load More" mode
        }
    };


    return (
        <>
            <section className="blogpage">
                <div className="container">
                    <div className="row">
                        {allData && allData.slice(0, visibleCount).map((data, index) => (
                            <div className="col-lg-4 col-sm-6" key={index}>
                                <Link to={`${data?.slug}/`} className="blogpost-box">
                                    <div className='blogpost-image'>
                                        <img src={data?.thumbnail ? `${BaseUrl}${data.thumbnail}` : undefined} loading="lazy" className="img-responsive" alt={data?.alt_thumbnail} />
                                        <span>{DateConvert(data?.date)}</span>
                                    </div>
                                    <div className='blogpost-detail'>
                                        <span>{data?.title?.slice(0, 50) + "..."}</span>
                                        <p>{data?.brief?.slice(0, 100) + "..."}</p>
                                        <div className='arrow-butn' >Learn More <img src="/assets/images/arrow.webp" loading="lazy" alt="arrow" /></div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                        <div className="col-lg-12">
                            <div className='text-center'>
                                <Link onClick={handleLoadMore} className="default-btn"><span> {isLoadMore ? "View More" : "View Less"}</span></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
